import type { SVGProps } from "react";
export interface ChatEllipsisIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ChatEllipsisIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ChatEllipsisIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M7.02 21.953c4.166 2.085 9.37 1.39 12.847-2.086 4.344-4.344 4.344-11.39 0-15.734s-11.39-4.344-15.734 0C.656 7.61-.038 12.814 2.047 16.98l-.76 3.17c-.348 1.447.853 2.76 2.276 2.612l.287-.049zm11.256-3.678a8.88 8.88 0 0 1-10.563 1.498 1.13 1.13 0 0 0-.806-.108l-3.385.813.813-3.385a1.13 1.13 0 0 0-.108-.806A8.88 8.88 0 0 1 5.725 5.724a8.875 8.875 0 0 1 12.55 12.55Z"
      />
      <path
        fill={color}
        d="M16 11.629a.62.62 0 0 0-.124.37l.011.127c.019.09.06.172.113.244zm1 .741a.6.6 0 0 0 .112-.244l.013-.127-.013-.125a.6.6 0 0 0-.111-.245zm-4.388-.496a.6.6 0 0 0-.111-.245v.741a.6.6 0 0 0 .11-.244l.014-.127zm-1.112-.245a.62.62 0 0 0-.124.37l.011.127c.019.09.06.172.113.244zm-3.388.245A.6.6 0 0 0 8 11.629v.741a.6.6 0 0 0 .11-.244l.014-.127-.013-.125ZM7 11.629a.62.62 0 0 0-.124.37l.011.127c.019.09.06.172.113.244zm2.126.37a1.625 1.625 0 0 1-3.242.167L5.875 12l.009-.165a1.625 1.625 0 0 1 1.616-1.46l.167.009a1.625 1.625 0 0 1 1.459 1.615m4.5 0a1.625 1.625 0 0 1-3.242.167L10.375 12l.009-.165A1.625 1.625 0 0 1 12 10.375l.167.009a1.625 1.625 0 0 1 1.459 1.615m4.5 0a1.625 1.625 0 0 1-3.242.167L14.875 12l.009-.165a1.625 1.625 0 0 1 1.616-1.459l.167.009A1.625 1.625 0 0 1 18.125 12Z"
      />
    </svg>
  );
}
